import { Typography } from "@mui/material";
import { ChipItem, ChipsContainer, ChipsWrapper } from "./Chips.style";

type OptionType<T> = {
  label: string;
  value: T;
} & Record<string, unknown>;

interface ChipsProps<T> {
  onSelectChip: (value: T) => void;
  selectedChip: T;
  label: string;
  options: OptionType<T>[];
  name: string;
}

function Chips<T>({
  onSelectChip,
  selectedChip,
  label,
  options,
  name,
}: ChipsProps<T>) {
  return (
    <ChipsWrapper>
      <Typography>{label}</Typography>
      <ChipsContainer data-testid={`${name}-chips-container`}>
        {options.map((option) => {
          const isSelected = selectedChip === option.value;
          return (
            <ChipItem
              data-testid={`${name}-chips-item`}
              isSelected={isSelected}
              key={`${name}-${option.value}`}
              onClick={() => {
                selectedChip !== option.value && onSelectChip(option.value);
              }}
              size="small"
              label={option.label}
              className={isSelected ? ".selected" : undefined}
            />
          );
        })}
      </ChipsContainer>
    </ChipsWrapper>
  );
}

export default Chips;
